<template>
  <div class="border-t border-gray-800 mt-12 pt-8 text-center text-sm">
    <p>© {{ currentYear }} AutoVolt.ai - Todos os direitos reservados</p>
  </div>
</template>

<script setup lang="ts">
const currentYear = new Date().getFullYear()
</script>